import React, { useEffect, useState } from 'react';

// @material-ui
import { makeStyles } from '@material-ui/core/styles';
import {
  Box, Button, Typography,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

import { Img } from 'react-image';
import { isEmpty } from 'lodash';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import StormLegend from '../../legend/StormLegend';

import { styles } from '../style';
import '../styles.css';

const useStyles = makeStyles(styles);

export default function StormDatalists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const isMounted = React.useRef(false);
  const hostApi = `${process.env.REACT_APP_API_URL}`;
  const placeHolder = 'https://via.placeholder.com/400x200?text=No%20Image&italic=true';
  const loadHolder = 'https://via.placeholder.com/400x200?text=Loading&italic=true';

  const [indianOcean, setindianOcean] = useState({
    desc: null,
    agency_link: null,
    agency_id: null,
    agency_name: null,
    media_path: loadHolder,
    media_date: null,
  });
  const [pacificOcean, setpacificOcean] = useState({
    desc: null,
    agency_link: null,
    agency_id: null,
    agency_name: null,
    media_path: loadHolder,
    media_date: null,
  });
  const [kochiStorm, setkochiStorm] = useState({
    desc: null,
    agency_link: null,
    agency_id: null,
    agency_name: null,
    media_path: loadHolder,
    media_date: null,
  });
  const [stormCreds, setstormCreds] = useState();

  const [arrayImage, setarrayImage] = useState({
    image_path: '',
    image_title: '',
    image_credits: '',
  });
  const [isOpen, setisOpen] = useState(false);
  const [photoIndex, setphotoIndex] = useState(0);

  useEffect(() => {
    function getData() {
      fetch(`${hostApi}/public/weather_img/india_ocean_ucl`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          if (!isMounted.current) {
            setindianOcean({
              desc: data.data.description.description_name.th,
              agency_link: data.data.agency.agency_link,
              agency_id: data.data.agency.agency_id,
              agency_name: data.data.agency.agency_name.en,
              media_path: `${hostApi}/shared/image?_csrf=&image=${data.data.cover_image.media_path}`,
              media_date: data.data.cover_image.media_datetime,
            });
            // arrayImage.push(`http://api2.thaiwater.net:9200/api/v1/thaiwater30//shared/image?_csrf=&image=${data.data.cover_image.media_path}`)
          }
        })
        .catch(() => { setindianOcean({ media_path: placeHolder }); });

      fetch(`${hostApi}/public/weather_img/pacific_ocean_ucl`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          if (!isMounted.current) {
            setpacificOcean({
              desc: data.data.description.description_name.th,
              agency_link: data.data.agency.agency_link,
              agency_id: data.data.agency.agency_id,
              agency_name: data.data.agency.agency_name.en,
              media_path: `${hostApi}/shared/image?_csrf=&image=${data.data.cover_image.media_path}`,
              media_date: data.data.cover_image.media_datetime,
            });
            // arrayImage.push(`http://api2.thaiwater.net:9200/api/v1/thaiwater30//shared/image?_csrf=&image=${data.data.cover_image.media_path}`)
          }
        })
        .catch(() => { setpacificOcean({ media_path: placeHolder }); });

      fetch(`${hostApi}/public/weather_img/cloud`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          if (!isMounted.current) {
            if (data.data.kochi === null) {
              setstormCreds('Digital Typhoon');
              setkochiStorm({ media_path: `${hostApi}/shared/image?_csrf=&image=${data.data.typhoon[1].media_path}` });
            } else {
              setstormCreds('Kochi University');
              setkochiStorm({
                media_path: `${hostApi}/shared/image?_csrf=&image=${data.data.kochi[0].media_path}`,
              });
            }
            // arrayImage.push(`http://api2.thaiwater.net:9200/api/v1/thaiwater30//shared/image?_csrf=&image=${data.data.kochi[0].media_path}`)
          }
        })
        .catch(() => { setkochiStorm({ media_path: placeHolder }); });
    }

    getData();

    return () => {
      isMounted.current = true;
    };
  }, [hostApi]);

  useEffect(() => {
    const tmpImgPath = [];
    const tmpImgTitle = [];
    const tmpImgCreds = [];

    tmpImgPath.push(pacificOcean.media_path);
    tmpImgPath.push(indianOcean.media_path);
    tmpImgPath.push(kochiStorm.media_path);
    tmpImgTitle.push(pacificOcean.desc);
    tmpImgTitle.push(indianOcean.desc);
    tmpImgTitle.push(t('ภาพเมฆที่ปกคลุมบริเวณประเทศไทย'));
    tmpImgCreds.push(pacificOcean.agency_name);
    tmpImgCreds.push(indianOcean.agency_name);
    tmpImgCreds.push(stormCreds);
    setarrayImage({
      image_path: tmpImgPath,
      image_title: tmpImgTitle,
      image_credits: tmpImgCreds,
    });
  }, [indianOcean, kochiStorm, pacificOcean, stormCreds, t]);

  return (
    <>
      {/* {hasError && (
        <div>
          An Error has occured
        </div>
      )} */}
      <Grid container spacing={5}>
        <Grid item xs={12} sm={12} md={5}>
          <Box display="block" mt={2}>
            <Box py={2}>
              <Typography className={classes.titleSub}>
                {t('แผนที่เส้นทางพายุที่อาจส่งผลกระทบต่อประเทศไทย')}
              </Typography>
            </Box>
            <Box display="flex" className={classes.bodyBox} height={{ md: 650 }} style={{ padding: '20px' }} justifyContent="center">
              <Box>
                <Box><Typography className={classes.titleSub}>{t('มหาสมุทรแปซิฟิก')}</Typography></Box>
                <Box>
                  <Button onClick={() => { setisOpen(true); setphotoIndex(0); }}>
                    <img aria-label="pacific storm" src={pacificOcean.media_path} width="80%" onError={() => { setpacificOcean({ media_path: 'http://www.tropicalstormrisk.com/tracker/dynamic/images/W.png' }); }} alt={pacificOcean.desc} className={classes.img} />
                  </Button>
                </Box>
                <Box><Typography className={classes.titleSub}>{t('มหาสมุทรอินเดีย')}</Typography></Box>
                <Box>
                  <Button onClick={() => { setisOpen(true); setphotoIndex(1); }}>
                    <img aria-label="indian ocean storm" src={indianOcean.media_path} width="80%" onError={() => { setindianOcean({ media_path: 'http://www.tropicalstormrisk.com/tracker/dynamic/images/I.png' }); }} alt={indianOcean.desc} className={classes.img} />
                  </Button>
                </Box>
                <Typography align="right" className={classes.powerBy}>
                  {t('ที่มา')}
                  {' '}
                  : University College London
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={7}>
          <Box display="block" mt={2}>
            <Box py={2}>
              <Typography className={classes.titleSub}>
                {t('ภาพเมฆที่ปกคลุมบริเวณประเทศไทย')}
              </Typography>
            </Box>
            <Box display="flex" className={classes.bodyBox} height={{ md: 650 }} style={{ padding: '20px' }} justifyContent="center">
              <Box>
                <Box>
                  <Button onClick={() => { setisOpen(true); setphotoIndex(2); }}>
                    <Img aria-label="himawari" src={kochiStorm.media_path} width="90%" alt={t('ภาพเมฆที่ปกคลุมบริเวณประเทศไทย')} className={classes.img} />
                  </Button>
                </Box>
                <Typography align="right" className={classes.powerBy}>
                  ที่มา :
                  {stormCreds}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <StormLegend />
      {isEmpty(arrayImage.image_path[photoIndex]) === false && isOpen && (
        <Lightbox
          mainSrc={arrayImage.image_path[photoIndex]}
          nextSrc={arrayImage.image_path[(photoIndex + 1) % arrayImage.image_path.length]}
          prevSrc={arrayImage.image_path[
            (photoIndex + arrayImage.image_path.length - 1)
            % arrayImage.image_path.length
          ]}
          imageTitle={arrayImage.image_title[photoIndex]}
          imageCaption={arrayImage.image_credits[photoIndex]}
          onCloseRequest={() => { setisOpen(false); setphotoIndex(1); }}
          onMovePrevRequest={() => setphotoIndex(
            (photoIndex + arrayImage.image_path.length - 1) % arrayImage.image_path.length,
          )}
          onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % arrayImage.image_path.length)}
          reactModalStyle={{
            overlay: { zIndex: '10000000' },
          }}
        />
      )}
    </>
  );
}
